<template>
  <el-tabs v-model="activeTab" :stretch="true">
    <el-tab-pane
      v-for="tab in tabs"
      :key="tab.index"
      :label="tab.label"
      :name="tab.index"
    >
      <component :is="tab.component" @data-change="onDataChange" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import PreviewContentUserProfileTab from '@/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentUserProfileTab.vue'
import PreviewContentCustomDataTab from '@/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentCustomDataTab.vue'
import { $can } from '@/core/utils/VueAcl'

export default {
  name: 'PreviewContentDataTabs',
  data() {
    return {
      selectedTab: '',
      profileId: null,
      customAttrs: null
    }
  },
  computed: {
    tabs() {
      let tabs = []
      let profileTab = {
        index: 'user_profile',
        label: 'User Profile',
        component: PreviewContentUserProfileTab
      }
      let customDataTab = {
        index: 'custom_data',
        label: 'Custom Data',
        component: PreviewContentCustomDataTab
      }

      if ($can('Profile::Read') && $can('UserPersonalData::Read')) {
        tabs.push(profileTab)
      }

      tabs.push(customDataTab)

      return tabs
    },
    activeTab: {
      get() {
        // If selectedTab is falsy get the default active tab from tabs computed property
        return this.selectedTab || this.tabs[0].index
      },
      set(selectedTab) {
        if (selectedTab === this.selectedTab) {
          return
        }

        // Reload preview after switch back to User Profile tab
        if (selectedTab === 'user_profile' && this.profileId) {
          this.$emit('data-change', this.profileId)
        }
        this.selectedTab = selectedTab
      }
    }
  },
  methods: {
    onDataChange($event) {
      if (typeof $event === 'string') {
        this.profileId = $event
      }

      this.$emit('data-change', $event)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentDataTabs.vue